import * as React from 'react'

import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import { ExecutionElement } from './ExecutionElement'
import { ElementLabel } from './ElementLabel'

import type * as Flows from '../../../shared/domain/flows/types.no-deps'
import type { CreateAnswer } from '../../../shared/domain/flows/answer.no-deps'
import { SearchableDropdown } from '../ui/SearchableDropdown'
import type { TimelineDetails } from './TimelineDetails'
import type { LoopPathIds } from '../../../shared/domain/flows/LoopPath.no-deps'

interface Props {
    deps: CommonDeps
    elementId: Flows.ElementId
    loopPathIds: LoopPathIds
    label: string
    timelineDetails: TimelineDetails
    required: boolean
    choices: Flows.DropdownChoice[]
    answerValue: Flows.DropdownAnswer['value']
    validationMessages: string[]
    createAnswer: CreateAnswer<Flows.DropdownAnswer>
    openOptions?: () => void
}

export class ElementDropdown extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    private tryRender = () => {
        const props = this.props
        const selectedValue = (props.answerValue && props.answerValue[0]) ?? null

        return (
            <ExecutionElement
                deps={props.deps}
                elementId={props.elementId}
                loopPathIds={this.props.loopPathIds}
                validationMessages={props.validationMessages}
                timelineDetails={props.timelineDetails}
            >
                <ElementLabel
                    required={props.required}
                    label={props.label}
                    hasBeenEdited={props.timelineDetails && props.timelineDetails.hasBeenEdited}
                    language={props.deps.language}
                    validationMessages={props.validationMessages}
                    openOptions={this.props.openOptions}
                />
                <div className="AppCore__flow__ElementDropdown">
                    <SearchableDropdown
                        language={props.deps.language}
                        options={props.choices}
                        selectedValue={selectedValue}
                        onChange={(newValue) => {
                            return props.createAnswer((base) => ({
                                ...base,
                                type: 'dropdown',
                                value: newValue === null ? [] : [newValue],
                            }))
                        }}
                    />
                </div>
            </ExecutionElement>
        )
    }
}
